// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderSale_wrapper__Ea757","left":"HeaderSale_left__alxuf","value":"HeaderSale_value__gz67+","add":"HeaderSale_add__gWuff"};